<template>
  <div>
    <bim-container>
      <BlockHead />
    </bim-container>
    
    <BlockBenefitsForManufacturers />

    <bim-container>
      <BlockNewOpportunities />
    </bim-container>

    <BlockVideo />

    <bim-container>
      <BlockHowItWorks />
    </bim-container>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer";

import BlockBenefitsForManufacturers from "./components/BlockBenefitsForManufacturers"
import BlockHead from "./components/BlockHead"
import BlockHowItWorks from "./components/BlockHowItWorks"
import BlockNewOpportunities from "./components/BlockNewOpportunities"
import BlockVideo from "./components/BlockVideo"

export default {
  name: "landing-gisp",
  components: {
    bimContainer,
    
    BlockBenefitsForManufacturers,
    BlockHead,
    BlockHowItWorks,
    BlockNewOpportunities,
    BlockVideo
  }
}
</script>

<style lang="scss" scoped>

</style>
